export default __webpack_public_path__ + "static/media/warningTost.e564870c.svg";